import { t } from '@i18n';
import { org_sector_type_enum } from '@predium/enums';
import { ICONS as ICONS_ENUM } from '@/assets/icons';
import Iconify from '@/components/Iconify';
import { NavConfigProps } from '@/components/nav-section/type';
import { PATHS } from '@/routes';
import {
  ConsumptionInvoicesTabEnum,
  DataCollectionEnergySuppliersTabEnum,
  StatusQuoAnalysisTabEnum,
} from '@/routes/search_params/searchParamsEnums';

const ICONS = {
  statusQuoAnalysis: Iconify({ icon: ICONS_ENUM.MDI_CHART_BAR_STACKED }),
  actionPlanning: Iconify({ icon: ICONS_ENUM.CHART_TIMELINE }),
  dataCollection: Iconify({ icon: ICONS_ENUM.DATABASE_OUTLINE }),
  documents: Iconify({ icon: ICONS_ENUM.MDI_FILE_DOCUMENT_MULTIPLE_OUTLINE }),
  drive: Iconify({ icon: ICONS_ENUM.PH_FOLDER }),
  reporting: Iconify({ icon: ICONS_ENUM.OCTICON_CHECKLIST_16 }),
};

type NavConfigParams = {
  isEconomicUnitsToggled: boolean;
  reportingToggled: boolean;
  cbiEnabled: boolean;
  consumptionHubEnabled: boolean;
  energyNetworksEnabled: boolean;
  appraisalReviewEnabled: boolean;
  orgSector: org_sector_type_enum;
  isAdmin: boolean;
};

const getNavConfig = ({
  isEconomicUnitsToggled,
  reportingToggled,
  cbiEnabled,
  consumptionHubEnabled,
  energyNetworksEnabled,
  appraisalReviewEnabled,
  orgSector,
  isAdmin,
}: NavConfigParams): NavConfigProps => {
  return [
    {
      subheader: '',
      items: [
        // Analysis (1st — primary workflow: analyze → plan → report, with data as the foundation underneath)
        {
          title: t('General_StatusQuoAnalysis'),
          path: 'ROUTE NOT USED',
          rootPathname: PATHS.statusQuoAnalysis.root(),
          icon: ICONS.statusQuoAnalysis,
          children: [
            {
              title: t('General_Building', { count: 2 }),
              path: PATHS.statusQuoAnalysis.buildings({
                tab: StatusQuoAnalysisTabEnum.DEMAND,
              }),
            },
            ...(isEconomicUnitsToggled
              ? [
                  {
                    title: t('General_EconomicUnit', { count: 2, orgSector }),
                    path: PATHS.statusQuoAnalysis.economicUnits({
                      tab: StatusQuoAnalysisTabEnum.DEMAND,
                    }),
                  },
                ]
              : []),
            {
              title: t('General_Portfolio', { count: 2 }),
              path: PATHS.statusQuoAnalysis.portfolio({
                tab: StatusQuoAnalysisTabEnum.DEMAND,
              }),
            },
          ],
        },
        {
          title: t('General_ActionPlanning'),
          rootPathname: PATHS.actionPlanning.root(),
          path: PATHS.actionPlanning.scenarios(),
          icon: ICONS.actionPlanning,
        },
        ...(reportingToggled
          ? [
              {
                title: t('General_Reporting'),
                rootPathname: PATHS.reporting.root(),
                path: PATHS.reporting.reports(),
                icon: ICONS.reporting,
              },
            ]
          : []),
        // Data (last — the underlying foundation for all above)
        {
          title: t('General_DataCollection'),
          rootPathname: PATHS.dataCollection.root(),
          path: 'ROUTE NOT USED',
          icon: ICONS.dataCollection,
          children: [
            {
              title: t('General_Building', { count: 2 }),
              path: PATHS.dataCollection.buildings(),
            },
            ...(isEconomicUnitsToggled
              ? [
                  {
                    title: t('General_EconomicUnit', { count: 2, orgSector }),
                    path: PATHS.dataCollection.economicUnits(),
                  },
                ]
              : []),
            ...(isAdmin
              ? [
                  {
                    title: t('General_Portfolio', { count: 2 }),
                    path: PATHS.dataCollection.portfolios(),
                  },
                ]
              : []),
            {
              title: t('DataCollection_EnergySupplier', { count: 2 }),
              path: PATHS.dataCollection.energySuppliers({ tab: DataCollectionEnergySuppliersTabEnum.ALL }),
            },
            ...(energyNetworksEnabled
              ? [
                  {
                    title: t('DataCollection_EnergyNetwork', { count: 2 }),
                    path: PATHS.dataCollection.energyNetworks(),
                  },
                ]
              : []),
            ...(cbiEnabled
              ? [
                  {
                    title: t('General_ConsumptionInvoices'),
                    path: PATHS.dataCollection.consumptionInvoices({ tab: ConsumptionInvoicesTabEnum.PROCESSING }),
                  },
                ]
              : []),
            ...(consumptionHubEnabled
              ? [
                  {
                    title: t('General_ConsumptionHub'),
                    path: PATHS.dataCollection.consumptionHub(),
                  },
                ]
              : []),
          ],
        },
        ...(appraisalReviewEnabled
          ? [
              {
                title: t('General_Document', { count: 2 }),
                rootPathname: PATHS.documents.root(),
                path: 'ROUTE NOT USED',
                icon: ICONS.documents,
                children: [
                  {
                    title: t('PageName_DataInbox'),
                    path: PATHS.documents.dataInbox(),
                  },
                  {
                    title: t('General_Drive'),
                    path: PATHS.drive.root(),
                  },
                ],
              },
            ]
          : [
              {
                title: t('General_Drive'),
                rootPathname: PATHS.drive.root(),
                path: PATHS.drive.root(),
                icon: ICONS.drive,
              },
            ]),
      ],
    },
  ];
};

export default getNavConfig;
